import React, { useState, useEffect } from 'react';
import cookieUtil from 'src/util/cookieUtil';
import { ECookieName } from '../util/utilModel';
import ThemeProvider from '../store/EnhancedThemeProvider';
import util from '../util/util';
import brandDomains from 'src/config/hostConfig'
export interface IAppContextStore {
	i18n: any;
	query: any;
	isStartFromServer: boolean;
	pageConfig: any;
	view: string;
	pathname: string;
	isMobileWidth: boolean;

	// from withUserInfo
	username: string;
	memberId: number;
	type: string; // account type
	lang: string;
	exchangeRate: number;
	isSubAccount: string;
	persona: IAssociations;
	personaString: string;
	bfInfo: IbfInfo[];

	// from withSystem
	showkey: string;
	ip: string;
	betBufferSec: number;
	token: string;
	brandId: number;
	currENV: string;
	showLiveTv: boolean;
	liveTvUrl: any;
	theme: any;
	isDarkTheme: boolean;

	// UI Auth
	handleLogin: boolean;
	handleSignup: boolean;
	userInfo: any;
	showTimer: boolean;
	showResend: boolean;
	setPage: number;
}

export interface IbfInfo {
	categoryId: number;
	bfPt: number;
}

export interface IAssociations {
	username: string;
	type: string;
	currencyId: number;
	exchangeRate: number;
	memberId: number;
}

export const getBrandId = (host: string = '') => {
	try {
		const refer = util.isClient ? (global as any).location.host : host;
		// let brandId = brandDomains.find(bd => refer.includes(bd.domain))?.id || 1;
		let brandId = brandDomains.find(bd => bd.domain === refer)?.id || 1;
		return brandId || 1;
	} catch (e) {
		console.error('Get brand id failed.', e);
		return 1;
	}
};

//to get the current environment according to the domain 
const getBrandEnv = (host: string = ''): string => {
  try {
    const refer = util.isClient ? (global as any).location.host : host;
   // console.log("Refer domain:", refer); // should show "localhost:3000"
    for (const bd of brandDomains) {
      if (refer.includes(bd.domain)) {
        return bd.dev || "UNKNOWN";
      }
    }

    return "UNKNOWN";
  } catch (e) {
    return "UNKNOWN";
  }
};


const initStore: IAppContextStore = {
	i18n: {},
	query: {},
	lang: cookieUtil.get(ECookieName.COOKIE_LANG) || 'manoj',
	isStartFromServer: true,
	pageConfig: {},
	username: '',
	view: '',
	exchangeRate: 1,
	showkey: '',
	type: '',
	pathname: '',
	memberId: 0,
	persona: {
		username: '',
		type: '',
		currencyId: 0,
		exchangeRate: 0,
		memberId: 0,
	},
	isMobileWidth: false,
	isSubAccount: '',
	bfInfo: [] as IbfInfo[],
	personaString: '',
	ip: '',
	betBufferSec: 1,
	token: '',
	brandId: getBrandId(),
	currENV: getBrandEnv(),
	showLiveTv: false,
	liveTvUrl: '',
	theme: cookieUtil.get(ECookieName.COOKIE_THEME) || 'Light',
	isDarkTheme: false,
	handleLogin: false,
	handleSignup: false,
	userInfo: {},
	showTimer: false,
	showResend: false,
	setPage: 0,

};

export const AppContext = React.createContext({});

export const AppContextProvider = (props) => {

	const { initData, children } = props;
	const [store, setStore] = useState(initStore);

	const setState = (data) => {
		setStore(prevState => {
			let newData = {
				...prevState,
				...data
			}
			return newData;
		})
	}
	useEffect(() => {
		setStore(prevState => {
			let newData = {
				...prevState,
				...initData,
			}
			return newData;
		})
	}, [initData]);

	return (
		<AppContext.Provider value={{ ...store, setState }}>
			<ThemeProvider view={'snk'} memberType={'CLIENT'} brandId={store.brandId}>
				{children}
			</ThemeProvider>
		</AppContext.Provider>
	)
}


export const withAppContext = (Child: any): any => {
	return class App extends React.Component<any, any> {
		//it's for next so we can rmove it later
		static async getInitialProps(ctx: any = {}): Promise<any> {
			if (Child.hasOwnProperty('getInitialProps')) {
				const context: any = (Object as any).assign(ctx, {});
				const childProps: any = (await Child.getInitialProps(context)) || {};
				return (Object as any).assign(childProps, {});
			} else {
				return {};
			}
		}
		render(): JSX.Element {
			return <AppContext.Consumer>{
				(app) => <Child {...this.props} app={app} />
			}
			</AppContext.Consumer>;
		}
	};
};